import axios from 'axios';
import { triggerAuthRefresh } from '../context/AuthContext'; // 💡 NUEVA IMPORTACIÓN

const RAW_BASE = process.env.REACT_APP_API_URL || 'https://frahda-backend.onrender.com/api/v1/';
const API_BASE_URL = RAW_BASE.endsWith('/') ? RAW_BASE : `${RAW_BASE}/`;

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: Agrega Token de Auth y Session Key limpia
api.interceptors.request.use(
  (config) => {
    // Asegurar que headers existe
    config.headers = config.headers || {};

    // --- LÓGICA ANTI-ZOMBIE (CORREGIDA) ---
    let sessionKey = localStorage.getItem('cart_session_key');

    // Lista negra de valores que causan el error del carrito compartido
    const BAD_KEYS = ['null', 'undefined', 'None', 'NaN', ''];

    // Si la llave es basura, la borramos para forzar una nueva
    if (sessionKey && BAD_KEYS.includes(sessionKey)) {
      console.warn('--- DEBUG: Llave corrupta detectada y eliminada ---', sessionKey);
      sessionKey = null;
      localStorage.removeItem('cart_session_key');
    }

    // Si no hay llave (o se borró por ser basura), generamos una nueva
    if (!sessionKey) {
      sessionKey = `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem('cart_session_key', sessionKey);
      console.log('--- DEBUG: Nueva session_key generada ---', sessionKey);
    }

    // Enviamos la llave limpia
    (config.headers as any)['X-Session-Key'] = sessionKey;
    // ---------------------------------------

    // Adjuntar token de acceso para usuarios logueados
    const token = localStorage.getItem('access_token');
    if (token) {
      (config.headers as any).Authorization = `Bearer ${token}`;
    }else {
      // Importante: Asegúrate de que no haya un header Authorization residual
      delete (config.headers as any).Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Maneja el refresco de tokens (Refresh Token)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const hadToken = Boolean(localStorage.getItem('access_token'));

    // Helper para logout forzado con mensaje
    const forceLogout = (message: string = 'Tu sesión ha expirado') => {
      console.warn('--- Forzando cierre de sesión por error de autenticación ---');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user');
      
      // Guardar mensaje de sesión expirada
      sessionStorage.setItem('session_expired_message', message);
      
      const isAdmin = window.location.pathname.startsWith('/admin');
      const isPublicPage = !isAdmin && !window.location.pathname.includes('/login');
      
      // Evitar bucle de redirección si ya estamos en login
      if (!window.location.pathname.includes('/login')) {
        if (isPublicPage) {
          // En página pública, recargar y mostrar notificación
          sessionStorage.setItem('show_session_expired_notification', 'true');
          window.location.reload();
        } else {
          // En admin, redirigir a login de admin inmediatamente
          window.location.href = '/admin/login';
        }
      }
    };

    // Manejo de autenticación: solo actuar si HABÍA token
    if ((error.response?.status === 401 || error.response?.status === 403) && hadToken) {
        // Si ya se reintentó y falló de nuevo, forzar salida
        if (originalRequest._retry) {
            forceLogout('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
            return Promise.reject(error);
        }

        originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const response = await axios.post(`${API_BASE_URL}users/token/refresh/`, {
            refresh: refreshToken,
          });
          
          const { access } = response.data;
          localStorage.setItem('access_token', access);
          (api.defaults.headers as any).Authorization = `Bearer ${access}`;
          
          triggerAuthRefresh(); // 💡 LLAMADA CLAVE PARA SINCRONIZAR
          
          return api(originalRequest);
        } else {
          // No hay refresh token, sesión expirada
          forceLogout('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
          return Promise.reject(error);
        }
      } catch (refreshError: any) {
        // Si falla el refresh (token expirado o error de red), cerramos sesión
        console.error('Error al refrescar token:', refreshError);
        forceLogout('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
        return Promise.reject(refreshError);
      }
    }
    
    // Si el error no tiene response (error de red, backend caído, etc.)
    // y el usuario está autenticado, verificar si el token es válido
    if (!error.response && hadToken) {
      console.warn('Error de red detectado, pero no se fuerza logout automáticamente');
      // Aquí NO forzamos logout porque puede ser un problema temporal de red
    }
    
    return Promise.reject(error);
  }
);

export default api;